import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "clearflex",
    staticStyle: {
      margin: "18px"
    }
  }, [_c("el-button", {
    staticClass: "fl-right",
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.authGameEnter
    }
  }, [_vm._v("确 定")])], 1), _c("el-checkbox", {
    attrs: {
      indeterminate: _vm.isIndeterminate
    },
    on: {
      change: _vm.handleCheckAllChange
    },
    model: {
      value: _vm.checkAll,
      callback: function callback($$v) {
        _vm.checkAll = $$v;
      },
      expression: "checkAll"
    }
  }, [_vm._v("全部权限")]), _c("el-checkbox-group", {
    staticStyle: {
      display: "flex",
      "flex-direction": "column",
      "margin-left": "15px"
    },
    on: {
      change: _vm.handleCheckedGamesChange
    },
    model: {
      value: _vm.checkedGames,
      callback: function callback($$v) {
        _vm.checkedGames = $$v;
      },
      expression: "checkedGames"
    }
  }, _vm._l(_vm.gameList, function (item, key) {
    return _c("el-checkbox", {
      key: key,
      attrs: {
        label: item.game_id
      }
    }, [_vm._v(_vm._s(item.name) + "（" + _vm._s(item.game_id) + "）")]);
  }), 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };